import React, { useState } from "react";
// Import if schools is stored separately:
import schools from "../assets/data/schools";
import SchoolOverview from "../school-components/SchoolOverview";
import WhyChooseSchool from "../school-components/WhyChooseSchools";
import DeansDeskSection from "../school-components/DeansDeskSections";
import { LearningMethodologyRenderer } from "../school-components/LearningMethodologySections";
import SchoolOutcomesSection from "../school-components/OutcomesSections";
import { CareerServicesPlacementsRenderer } from "../school-components/CareerServicesPlacementSections";
import SchoolFAQSection from "../school-components/FAQSections";
import { AdmissionEligibilityRenderer } from "../school-components/AdmissionEligibilitySections";
import { LeadCaptureFooterContactRenderer } from "../school-components/LeadCaptureFooterContactSections";


import banner from "../assets/img/schoolbanner/school-of-management.webp";

function Programmes() {
    const [activeSchool, setActiveSchool] = useState(schools[0]?.id || "");

    const selectedSchool =
        schools.find((school) => school.id === activeSchool) || schools[0];

    return (
        <section className="programmes-section" id="programmes">
            <div className="container mx-auto">

                <div className="programme-heading-row">
                    <div className="programme-heading-content">
                        <div className="programme-eyebrow">
                            <span />
                            Academic Programmes
                        </div>

                        <h2>
                            Career-First Schools of
                            <em> Learning</em>
                        </h2>

                        <p>
                            Explore future-ready Schools of Learning for undergraduate, postgraduate, doctoral and diploma programmes for paramount academic excellence and bespoke industry collaboration.
                        </p>
                    </div>

                    <a href="/programmes" className="programme-main-btn">
                        <span>View all programmes</span>
                        <i>↗</i>
                    </a>
                </div>

                <div className="programme-layout">

                    <aside className="school-navigation">
                        <div className="school-nav-heading">
                            <small>Explore by school</small>
                            <strong>{schools.length} Academic Schools</strong>
                        </div>

                        <div
                            className="school-tabs"
                            role="tablist"
                            aria-label="Academic schools"
                        >
                            {schools.map((school, index) => (
                                <button
                                    key={school.id}
                                    type="button"
                                    role="tab"
                                    className={`school-tab ${activeSchool === school.id ? "active" : ""
                                        }`}
                                    aria-selected={activeSchool === school.id}
                                    onClick={() => setActiveSchool(school.id)}
                                >
                                    <span className="school-tab-number">
                                        {String(index + 1).padStart(2, "0")}
                                    </span>

                                    <span className="school-tab-title">
                                        {school.title}
                                        <small>{school.courses.length} programmes</small>
                                    </span>

                                    <i>→</i>
                                </button>
                            ))}
                        </div>
                    </aside>

                    <div className="programme-content">
                        <div className="selected-school-header">
                            <div>
                                <small>Currently exploring</small>
                                <h3>{selectedSchool?.title}</h3>
                            </div>

                            <span className="course-count">
                                <strong>{selectedSchool?.courses.length || 0}</strong>
                                Programmes
                            </span>
                        </div>

                        {selectedSchool?.courses.length > 0 ? (
                            <div className="programme-card-grid">
                                {selectedSchool.courses.map((course, index) => (
                                    <article className="programme-card" key={course.name || index}>
                                        <div className="programme-card-top">
                                            <span className="programme-level">
                                                {course.level || "Programme"}
                                            </span>

                                            <span className="programme-card-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </span>
                                        </div>

                                        <div className="programme-card-content">
                                            <p className="programme-department">
                                                {course.department}
                                            </p>

                                            <h4>{course.title}</h4>

                                            <div className="programme-information">
                                                <div>
                                                    <span>Duration</span>
                                                    <strong>{course.duration || "Contact University"}</strong>
                                                </div>

                                                <div>
                                                    <span>Study Mode</span>
                                                    <strong>{course.mode || "Regular"}</strong>
                                                </div>
                                            </div>

                                            <div className="programme-eligibility">
                                                <span>Eligibility</span>
                                                <p>{course.eligibility || "Contact University"}</p>
                                            </div>
                                        </div>

                                        <a
                                            href={`/course/${course.name}`}
                                            className="programme-card-link"
                                            aria-label={`Explore ${course.title}`}
                                        >
                                            <span>Explore programme</span>
                                            <i>↗</i>
                                        </a>
                                    </article>
                                ))}
                            </div>
                        ) : (
                            <div className="no-programmes">
                                <span>01</span>
                                <h4>Programmes coming soon</h4>
                                <p>
                                    Programme information for this school will be available soon.
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                <div className="programme-stats">
                    <div className="stat-intro">
                        <small>ISBM University</small>
                        <strong>Learning without limits.</strong>
                    </div>

                    <div className="programme-stat">
                        <strong>120+</strong>
                        <span>Programmes</span>
                    </div>

                    <div className="programme-stat">
                        <strong>18</strong>
                        <span>Academic Schools</span>
                    </div>

                    <div className="programme-stat">
                        <strong>250+</strong>
                        <span>Faculty Members</span>
                    </div>

                    <div className="programme-stat">
                        <strong>5000+</strong>
                        <span>Students</span>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default Programmes;